import type { getEnvironmentGalleryComponent } from "@/lib/api/formatting/rorosTweed/productPage";
import useMediaGallery from "@/lib/hooks/useMediaGallery";

import UI from "./UI";

type ImageGridProps =
  | Partial<ReturnType<typeof getEnvironmentGalleryComponent>>
  | undefined;

const ImageGrid = (props: ImageGridProps) => {
  const { findMedia } = useMediaGallery("In use");

  const newProps = {
    ...props,
    media: props?.media?.map((media) => ({
      ...media,
      callback: () => findMedia(media),
    })),
  };

  return <UI {...newProps} />;
};

export default ImageGrid;
